(function() {
  'use strict';

  angular
    .module('traineeWebApp.services')
    .factory('Validation', Validation);

  Validation.$inject = [];

  function Validation() {
    var validationArr = [];

    return {
      validate: function() {
        if (validationArr.length > 0) {
          return validationArr[0]();
        }

        return true;
      },

      getValidations: function() {
        return validationArr.concat();
      },

      addValidation: function(cb) {
        validationArr.push(cb);
      },

      removeValidation: function(cb) {
        validationArr = [];
      },

      removeAllValidations: function() {
        validationArr = [];
      }
    };
  }
})();